import { render, staticRenderFns } from "./SwFooter.vue?vue&type=template&id=b60c4096&scoped=true&"
import script from "./SwFooter.vue?vue&type=script&lang=js&"
export * from "./SwFooter.vue?vue&type=script&lang=js&"
import style0 from "./SwFooter.vue?vue&type=style&index=0&id=b60c4096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60c4096",
  null
  
)

export default component.exports